import ReadAndSelect from "./ReadAndSelect";
import WriteAboutPhoto from "./WriteAboutPhoto";
import ReadThenWrite from "./ReadThenWrite";
import WritingSample from "./WritingSample";
import ReadAndComplete from "./ReadAndComplete";
import CompleteTheSentences from "./CompleteTheSentences";
import CompleteThePassage from "./CompleteThePassage";
import HighlightTheAnswer from "./HighlightTheAnswer";
import IdentifyTheIdea from "./IdentifyTheIdea";
import TitleThePassage from "./TitleThePassage";
import ReadAloud from "./ReadAloud";
import SpeakAboutPhoto from "./SpeakAboutPhoto";
import ReadThenSpeak from "./ReadThenSpeak";
import ListenThenSpeak from "./ListenThenSpeak";
import SpeakingSample from "./SpeakingSample";
import ListenAndType from "./ListenAndType";
import SummarizeTheScenario from "./SumarizeTheScenario";
import ListenAndRespond from "./ListenAndRespond";
import ReadAndSelectNew from "./ReadAndSelectNew";
import InteractiveWriting from "./InteractiveWriting";
import FillInTheBlank from "./FillInTheBlank";
import InteractiveListening from "./InteractiveListening";
import InteractiveSpeaking from "./InteractiveSpeaking";


export default [
    {
        Component: InteractiveSpeaking,
        path: "/interactive-speaking/:id"
    },
    {
        Component: ReadAndSelect,
        path: "/read-and-select/:id"
    }, {
        Component: InteractiveWriting,
        path: "/interactive-writing/:id"
    }, {
        Component: ReadAndSelectNew,
        path: "/read-and-select-new/:id"
    }, {
        Component: WriteAboutPhoto,
        path: "/write-about-the-photo/:id"
    }, {
        Component: ReadThenWrite,
        path: "/read-then-write/:id"
    }, {
        Component: WritingSample,
        path: "/writing-sample/:id"
    }, {
        Component: ReadAndComplete,
        path: "/read-and-complete/:id"
    }, {
        Component: FillInTheBlank,
        path: "/fill-in-the-blanks/:id"
    }, {
        Component: CompleteTheSentences,
        path: "/complete-the-sentences/:id"
    }, {
        Component: CompleteThePassage,
        path: "/complete-the-passage/:id"
    }, {
        Component: HighlightTheAnswer,
        path: "/highlight-the-answer/:id"
    }, {
        Component: IdentifyTheIdea,
        path: "/identify-the-idea/:id"
    }, {
        Component: TitleThePassage,
        path: "/title-the-passage/:id"
    }, {
        Component: ReadAloud,
        path: "/read-aloud/:id"
    }, {
        Component: SpeakAboutPhoto,
        path: "/speak-about-the-photo/:id"
    }, {
        Component: ReadThenSpeak,
        path: "/read-then-speak/:id"
    }, {
        Component: ListenThenSpeak,
        path: "/listen-then-speak/:id"
    }, {
        Component: SpeakingSample,
        path: "/speaking-sample/:id"
    }, {
        Component: ListenAndType,
        path: "/listen-and-type/:id"
    }, {
        Component: SummarizeTheScenario,
        path: "/summarize-the-conversation/:id"
    }, {
        Component: ListenAndRespond,
        path: "/listen-and-respond/:id"
    },


    {
        Component: InteractiveListening,
        path: "/interactive-listening/:id"
    }


]
